import {
  PayoutIcon1SvgIcon,
  PayoutIcon2SvgIcon,
  PayoutIcon3SvgIcon,
  PayoutIcon4SvgIcon,
  PayoutRectangleIcon1SvgIcon,
  PayoutRectangleIcon2SvgIcon,
  PayoutRectangleIcon3SvgIcon,
  PayoutRectangleIcon4SvgIcon
} from 'utils/icons';
import './index.scss';
import currencyFormat from 'utils/currencyFormat';
import { Button, Space, Tag, Typography, Col, Dropdown } from 'antd';
import { CUMMALATIVE_PAYOUT_SUMMARY_STATUS } from 'constants/status';
import { EyeOutlined, DownOutlined } from '@ant-design/icons';
import { cummlativeReportStatus } from 'constants';
import dayjs from 'dayjs';

const getCummaltiveSummaryCards = (cummaltiveSummaryCards) => {
  return [
    {
      label: 'Total Commission',
      value: currencyFormat(cummaltiveSummaryCards?.cummalative_commission_amount ?? 0, true, true),
      icon: <PayoutIcon1SvgIcon style={{ fontSize: '40px' }} />,
      rect: (
        <div className="payout-rectangle-icon">
          <PayoutRectangleIcon1SvgIcon
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover' // ensures it fills the div nicely
            }}
          />
        </div>
      )
    },
    {
      label: 'Total TDS',
      value: currencyFormat(cummaltiveSummaryCards?.cummalative_tds_amount ?? 0, true, true),
      icon: <PayoutIcon2SvgIcon style={{ fontSize: '40px' }} />,
      rect: (
        <div className="payout-rectangle-icon">
          <PayoutRectangleIcon2SvgIcon
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover' // ensures it fills the div nicely
            }}
          />
        </div>
      )
    },
    {
      label: 'Total GST',
      value: currencyFormat(cummaltiveSummaryCards?.cummalative_gst_amount ?? 0, true, true),
      icon: <PayoutIcon3SvgIcon style={{ fontSize: '40px' }} />,
      rect: (
        <div className="payout-rectangle-icon">
          <PayoutRectangleIcon3SvgIcon
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover' // ensures it fills the div nicely
            }}
          />
        </div>
      )
    },
    {
      label: 'Total Paid Amount',
      value: currencyFormat(
        cummaltiveSummaryCards?.cummalative_actual_payout_amount ?? 0,
        true,
        true
      ),
      icon: <PayoutIcon4SvgIcon style={{ fontSize: '40px' }} />,
      rect: (
        <div className="payout-rectangle-icon">
          <PayoutRectangleIcon4SvgIcon
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover' // ensures it fills the div nicely
            }}
          />
        </div>
      )
    }
  ];
};

const columnStyles = {
  fontWeight: 700,
  fontSize: '14px',
  textAlign: 'center',
  width: '100%',
  whiteSpace: 'nowrap'
};
const textStyle = {
  fontSize: '14px',
  width: '100%'
};

const generateColumn = (title, dataIndex, key, render, align = 'left') => ({
  title: <Typography.Text style={columnStyles}>{title}</Typography.Text>,
  dataIndex,
  key,
  render,
  align
});

const getCummaltivePayoutColumns = (
  handleOpen,
  handlePayoutDownload,
  handleInvoiceDownload,
  downloadReport
) => {
  /* eslint-disable camelcase */

  return [
    generateColumn('Month', 'payout_month', 'payoutMonth', (_, record) => (
      <Typography.Link style={textStyle} onClick={() => handleOpen(record?.payout_month_id)}>
        {record?.payout_month ? dayjs(record?.payout_month, 'YYYYMM').format('MMMM') : ''}
      </Typography.Link>
    )),
    generateColumn(
      'Commission (₹)',
      'cummalative_commission_amount',
      'cumalativeCommissionAmount',
      (cumalative_commission_amount) => (
        <Typography.Text style={textStyle}>
          {currencyFormat(cumalative_commission_amount, true, true)}
        </Typography.Text>
      )
    ),
    generateColumn('TDS (₹)', 'cummalative_tds_amount', 'tdsAmount', (tds_amount) => (
      <Typography.Text style={textStyle}>{currencyFormat(tds_amount, true, true)}</Typography.Text>
    )),
    generateColumn('GST (₹)', 'cummalative_gst_amount', 'gstAmount', (gst_amount) => (
      <Typography.Text style={textStyle}>{currencyFormat(gst_amount, true, true)}</Typography.Text>
    )),
    generateColumn(
      'Pending GST (₹)',
      'cummalative_pending_gst_amount',
      'cummalative_pending_gst_amount',
      (cummalative_pending_gst_amount) => (
        <Typography.Text style={textStyle}>
          {currencyFormat(cummalative_pending_gst_amount, true, true)}
        </Typography.Text>
      )
    ),
    generateColumn('Status', 'status', 'status', (status) => (
      <Typography.Text style={textStyle}>
        {' '}
        <Tag
          color={CUMMALATIVE_PAYOUT_SUMMARY_STATUS[status]?.bgColor}
          style={{
            padding: '2px 13px',
            color: CUMMALATIVE_PAYOUT_SUMMARY_STATUS[status]?.color
          }}
        >
          {CUMMALATIVE_PAYOUT_SUMMARY_STATUS[status]?.label}
        </Tag>
      </Typography.Text>
    )),
    {
      title: <Space>Actions</Space>,
      align: 'center',
      render: (record) => {
        return (
          <div
            style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}
            id={record?.payout_month_id}
          >
            <Col key={record?.payout_month_id} id={record?.payout_month_id}>
              <Dropdown
                menu={{
                  items: [
                    {
                      label: (
                        <Typography.Link
                          onClick={() => handlePayoutDownload(record?.payout_month_id)}
                          href="#"
                        >
                          Payout Report
                        </Typography.Link>
                      ),
                      key: '0'
                    },
                    {
                      label: (
                        <Typography.Link
                          disabled={!record?.can_download_cummalative_invoice}
                          onClick={() => handleInvoiceDownload(record?.payout_month_id)}
                          href="#"
                        >
                          Invoice
                        </Typography.Link>
                      ),
                      key: '1'
                    }
                  ]
                }}
                trigger={['click']}
              >
                <Button
                  type="primary"
                  id={record?.payout_month_id}
                  loading={downloadReport === record?.payout_month_id}
                >
                  <Space>
                    Download
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            </Col>
          </div>
        );
      }
    }
  ];
};

const getMonthBasedPayoutCards = (monthBasedSummaryCards) => {
  return [
    {
      label: 'Total Commission',
      value: currencyFormat(monthBasedSummaryCards?.cummalative_commission_amount ?? 0, true, true),
      icon: <PayoutIcon1SvgIcon style={{ fontSize: '40px' }} />,
      rect: (
        <div className="payout-rectangle-icon">
          <PayoutRectangleIcon1SvgIcon
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover' // ensures it fills the div nicely
            }}
          />
        </div>
      )
    },
    {
      label: 'Total TDS',
      value: currencyFormat(monthBasedSummaryCards?.cummalative_tds_amount ?? 0, true, true),
      icon: <PayoutIcon2SvgIcon style={{ fontSize: '40px' }} />,
      rect: (
        <div className="payout-rectangle-icon">
          <PayoutRectangleIcon2SvgIcon
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover' // ensures it fills the div nicely
            }}
          />
        </div>
      )
    },
    {
      label: 'Total GST',
      value: currencyFormat(monthBasedSummaryCards?.cummalative_gst_amount ?? 0, true, true),
      icon: <PayoutIcon3SvgIcon style={{ fontSize: '40px' }} />,
      rect: (
        <div className="payout-rectangle-icon">
          <PayoutRectangleIcon3SvgIcon
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover' // ensures it fills the div nicely
            }}
          />
        </div>
      )
    },
    {
      label: 'Total Paid Amount',
      value: currencyFormat(
        monthBasedSummaryCards?.cummalative_actual_payout_amount ?? 0,
        true,
        true
      ),
      icon: <PayoutIcon4SvgIcon style={{ fontSize: '40px' }} />,
      rect: (
        <div className="payout-rectangle-icon">
          <PayoutRectangleIcon4SvgIcon
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover' // ensures it fills the div nicely
            }}
          />
        </div>
      )
    }
  ];
};

const getMonthBasedPayoutReport = (handleViewDetails) => {
  return [
    generateColumn('Month', 'payout_month', 'payoutMonth', (_, record) => (
      <Typography.Text style={textStyle}>{record?.payout_month}</Typography.Text>
    )),
    generateColumn(
      'Commission (₹)',
      'cumalative_commission_amount',
      'cumalativeCommissionAmount',
      (cumalative_commission_amount) => (
        <Typography.Text style={textStyle}>{cumalative_commission_amount}</Typography.Text>
      )
    ),
    generateColumn('TDS (₹)', 'tds_amount', 'tdsAmount', (tds_amount) => (
      <Typography.Text style={textStyle}>{tds_amount}</Typography.Text>
    )),
    generateColumn('GST (₹)', 'gst_amount', 'gstAmount', (gst_amount) => (
      <Typography.Text style={textStyle}>{gst_amount}</Typography.Text>
    )),
    generateColumn(
      'Pending GST (₹)',
      'pending_gst_amount',
      'pending_gst_amount',
      (pending_gst_amount) => (
        <Typography.Text style={textStyle}>{pending_gst_amount}</Typography.Text>
      )
    ),
    generateColumn('Status', 'status', 'status', (status) => (
      <Typography.Text style={textStyle}>
        {' '}
        <Tag
          color={CUMMALATIVE_PAYOUT_SUMMARY_STATUS[status]?.bgColor}
          style={{
            padding: '2px 13px',
            color: CUMMALATIVE_PAYOUT_SUMMARY_STATUS[status]?.color,
            fontSize: '12px',
            marginLeft: '10px'
          }}
        >
          {CUMMALATIVE_PAYOUT_SUMMARY_STATUS[status]?.label}
        </Tag>
      </Typography.Text>
    )),
    {
      title: <Space>Actions</Space>,
      align: 'center',
      render: (r) => {
        return (
          <div>
            <Button
              size="medimum"
              style={{ borderColor: 'var(--color-primary)' }}
              icon={
                <EyeOutlined
                  style={{ color: 'var(--color-primary)' }}
                  onClick={() => handleViewDetails(r)}
                />
              }
            />
          </div>
        );
      }
    }
  ];
};

const cummalativePayoutReportfiltersArr = [
  {
    attr: 'year',
    label: 'Select Year',
    type: 'Year'
  },
  {
    attr: 'month',
    label: 'Select Month',
    type: 'financialMonth'
  },
  {
    attr: 'status',
    label: 'Status',
    data: cummlativeReportStatus
  }
];

//  while invoice upload add the loading
export {
  getCummaltiveSummaryCards,
  getCummaltivePayoutColumns,
  getMonthBasedPayoutReport,
  cummalativePayoutReportfiltersArr,
  getMonthBasedPayoutCards
};
